import { DAY_FORMAT } from "../consts";

export function getDaysInMonth(availableDate: string) {
  const splitDate = availableDate.split("-");
  const month = Number.parseInt(splitDate[1]) - 1;
  const year = Number.parseInt(splitDate[0]);
  const date = new Date(year, month);
  const days = [];

  while (date.getMonth() === month) {
    const day = DAY_FORMAT.format(date);
    days.push(day.toString());
    date.setDate(date.getDate() + 1);
  }

  // "days" is an array, includes every day in a specific month in correct format
  return days;
}
